export default __webpack_public_path__ + "static/media/folder-open.6d44561d.svg";